import APIV5 from '~/models/api';
import { NodeService as NodeServiceModel } from '~/scripts/services/model/node-service';
import query from './bookmark.query.json';

/* globals Knitiv, Bookmark */

export default class BookmarkModel {
	/* @ngInject */
	/**
	 * @param {Knitiv.RootScope} $rootScope
	 * @param {import('angular').ITimeoutService} $timeout
	 * @param {import('angular').translate.ITranslateService} $translate
	 * @param {NodeServiceModel} NodeService
	 * @param {any} Notification
	 */
	constructor($rootScope, $timeout, $translate, NodeService, Notification) {
		this.$rootScope = $rootScope;
		this.$timeout = $timeout;
		this.$translate = $translate;
		this.NodeService = NodeService;
		this.Notification = Notification;
	}

	/**
	 * @param {string} name
	 * @param {Bookmark.SavedBookmark} data
	 * @returns {Promise<any>}
	 */
	async add(name, data) {
		const bookmark = this.NodeService.create('K_NODE;KSYSFAVORI');
		bookmark.addAttribute({ name: 'FAVORI', ref_type: 'KEPLER_TYPE;JSON', value: data });
		bookmark.setName(name);
		await this.NodeService.update(bookmark);
		this.Notification.info({
			title:     this.$translate.instant('common.info'),
			message:   this.$translate.instant('search.bookmark-added'),
		});
		this.$timeout(() => this.$rootScope.$apply());
	}

	/**
	 * @param {import('@knitiv/api-client-javascript').KNode} kid
	 * @returns {Promise<any>}
	 */
	delete(kid) {
		return this.NodeService.delete(kid);
	}

	// eslint-disable-next-line class-methods-use-this
	list() {
		// @ts-ignore
		return APIV5.instance.queryExec({ query }, { id: 'bookmark.list' });
	}

	/**
	 * @param {any} bookmark
	 * @param {string} newName
	 * @returns {Promise<any>}
	 */
	async rename(bookmark, newName) {
		const b = await this.NodeService.load(bookmark.kid);
		if (b) {
			b.setName(newName);
			await this.NodeService.update(b);
			this.Notification.info({
				title:   this.$translate.instant('common.info'),
				message: this.$translate.instant('search.bookmark-updated'),
			});
		}
		this.$timeout(() => this.$rootScope.$apply());
	}
}
